import {
  KHACHHANG_THEMMOI,
  KHACHHANG_THEMMOI_SUCCESS,
  KHACHHANG_THEMMOI_FAILURE,
} from "actions/DanhSachKhachHang/ThemMoiKhachHang/actionTypes";

const initialState = {
  themMoiKhachHangLoading: false,
};

const themMoiKhachHang = (state, action) => ({
  ...state,
  themMoiKhachHangLoading: true,
});

const themMoiKhachHangSuccess = (state, action) => {
  return {
    ...state,
    themMoiKhachHangLoading: false,
  };
};

const themMoiKhachHangFailed = (state, action) => ({
  ...state,
  themMoiKhachHangLoading: false,
});

const themMoiKhachHangReducer = (state = initialState, action) => {
  switch (action.type) {
    case KHACHHANG_THEMMOI:
      return themMoiKhachHang(state, action);
    case KHACHHANG_THEMMOI_SUCCESS:
      return themMoiKhachHangSuccess(state, action);
    case KHACHHANG_THEMMOI_FAILURE:
      return themMoiKhachHangFailed(state, action);
    default:
      return state;
  }
};

export default themMoiKhachHangReducer;
